import { GeneralFetch } from "Api/generalFetch/generalFetch";
import { useState } from "react";

export function useGetBest() {
    const { fetchData, loading } = GeneralFetch()
    const [theBest, setTheBest] = useState(null)

    async function getBestNearMiss(id) {
        await fetchData({}, `getBest/${id}`, 'get', 'best').then((data) => {

            if (data?.best?.length > 0) {
                const mes = data?.best?.[0]?.mes
                const ano = data?.best?.[0]?.ano
                setTheBest({ label: `Best near miss de ${mes ? mes : ""}${ano && mes ? mes + " e de " + ano : ""}${ano ? ano : ""}`, obs: data?.best?.[0]?.obs })
            } else
                setTheBest(null)
        })
    }

    return { getBestNearMiss, loading, theBest }
}